import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "card"
}
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "d-flex align-items-end gap-4" }
const _hoisted_7 = { class: "card-toolbar" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }

import { ref, onMounted } from "vue";
import LoadingRing from "@/components/LoadingRing.vue";
import NoDataBox from "@/components/NoDataBox.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import TableFooter from "@/components/TableFooter.vue";
import PaymentService from "../services/PaymentService";
import ChangeCreditForm from "@/projects/tenant/modules/Payment/components/ChangeCreditForm.vue";
import ChangeAdjustForm from "@/projects/tenant/modules/Payment/components/ChangeAdjustForm.vue";
import BatchIndex from "@/projects/tenant/modules/Payment/components/modal/BatchIndex.vue";
import {
  creditAdjustTypes,
  creditAdjustTypeOptions,
  AdjustRecordStatusTypes,
} from "@/core/types/CreditAdjustTypes";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreditIndex',
  setup(__props) {

const t = useI18n().t;
const isLoading = ref(false);
const changeCreditFormRef = ref<InstanceType<typeof ChangeCreditForm>>();
const changeAdjustFormRef = ref<InstanceType<typeof ChangeAdjustForm>>();
const data = ref<any>({});
const tabOptions = [
  {
    name: t("fields.manual"),
    id: 1,
    permission: ["TenantAdmin", "WebCreditAdjustment"],
  },
  {
    name: t("fields.batch"),
    id: 2,
    permission: ["TenantAdmin", "WebBatchAdjust"],
  },
];
const tab = ref(1);

const isTabActive = (_tab: number) => {
  return _tab === tab.value;
};
const changeTab = (id: number) => {
  tab.value = id;
};

const criteria = ref<any>({
  page: 1,
  size: 20,
  adjustBatchId: 0,
});
const reset = async () => {
  criteria.value = {
    page: 1,
    size: 20,
    adjustBatchId: 0,
  };
  fetchData(1);
};

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const res = await PaymentService.getAdjustRecord(criteria.value);
    data.value = res.data;
    criteria.value = res.criteria;
  } catch (e) {
    MsgPrompt.error(e);
    console.log(e);
  }
  isLoading.value = false;
};

const onEventSubmitted = () => {
  reset();
};

onMounted(() => {
  fetchData(1);
});

const openChangeCreditPanel = () => {
  changeCreditFormRef.value?.show();
};

const openChangeAdjustPanel = () => {
  changeAdjustFormRef.value?.show();
};

const getType = (status: number) => {
  if (status === AdjustRecordStatusTypes.completed) {
    return "success";
  } else if (status === AdjustRecordStatusTypes.failed) {
    return "danger";
  } else if (status === AdjustRecordStatusTypes.processing) {
    return "warning";
  } else if (status === AdjustRecordStatusTypes.deleted) {
    return "info";
  } else {
    return "primary";
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabOptions, (tab) => {
        return _createElementVNode("li", {
          class: "nav-item",
          key: tab.id
        }, [
          (_ctx.$cans(tab.permission))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: _normalizeClass(["nav-link text-active-primary pb-4", [
          { active: isTabActive(tab.id) },
          { 'disabled opacity-50 pe-none': isLoading.value },
        ]]),
                "data-bs-toggle": "tab",
                href: "#",
                onClick: ($event: any) => (changeTab(tab.id))
              }, _toDisplayString(tab.name), 11, _hoisted_2))
            : _createCommentVNode("", true)
        ])
      }), 64))
    ]),
    (tab.value === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_input, {
                    modelValue: criteria.value.accountNumber,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.accountNumber) = $event)),
                    placeholder: "Login NO."
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_select, {
                    modelValue: criteria.value.type,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.type) = $event)),
                    clearable: "",
                    placeholder: _unref(t)('fields.type')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(creditAdjustTypeOptions), (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (fetchData(1))),
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_button, {
                    onClick: reset,
                    type: "info",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_button, {
                type: "success",
                onClick: openChangeCreditPanel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.changeCredit")), 1)
                ]),
                _: 1
              }),
              (_ctx.$can('TenantAdmin'))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "success",
                    onClick: openChangeAdjustPanel
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("action.changeAdjust")), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.type")), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.accountNo")), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.role")), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.salesCode")), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.ticket")), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.staff")), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.amount")), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.remark")), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.status")), 1)
                ])
              ]),
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                    _createVNode(LoadingRing)
                  ]))
                : (!isLoading.value && data.value.length == 0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                      _createVNode(NoDataBox)
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(_unref(creditAdjustTypes)[item.type]), 1),
                          _createElementVNode("td", null, _toDisplayString(item.accountNumber), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.accountRole.${item.role}`)), 1),
                          _createElementVNode("td", null, _toDisplayString(item.code), 1),
                          _createElementVNode("td", null, _toDisplayString(item.ticket), 1),
                          _createElementVNode("td", null, _toDisplayString(item.operatorName), 1),
                          _createElementVNode("td", null, [
                            _createVNode(_component_TimeShow, {
                              type: "inFields",
                              "date-iso-string": item.createdOn
                            }, null, 8, ["date-iso-string"])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(item.amount / 100), 1),
                          _createElementVNode("td", null, _toDisplayString(item.comment), 1),
                          _createElementVNode("td", null, [
                            _createVNode(_component_el_tag, {
                              size: "small",
                              type: getType(item.status)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t(`status.${_unref(AdjustRecordStatusTypes)[item.status]}`)), 1)
                              ]),
                              _: 2
                            }, 1032, ["type"])
                          ])
                        ]))
                      }), 128))
                    ]))
            ])
          ]),
          _createVNode(TableFooter, {
            onPageChange: fetchData,
            criteria: criteria.value
          }, null, 8, ["criteria"])
        ]))
      : (_openBlock(), _createBlock(BatchIndex, { key: 1 })),
    _createVNode(ChangeCreditForm, {
      ref_key: "changeCreditFormRef",
      ref: changeCreditFormRef,
      onEventSubmit: onEventSubmitted
    }, null, 512),
    _createVNode(ChangeAdjustForm, {
      ref_key: "changeAdjustFormRef",
      ref: changeAdjustFormRef,
      onEventSubmit: onEventSubmitted
    }, null, 512)
  ], 64))
}
}

})